import { FC } from 'react'
import { Filial } from '@models/filial'
import Accordion, { AccordionHeaderProps } from '@organisms/Accordion'
import { ListItemProps } from '@templates/List'
import { ReactComponent as ArrowDownIconActive } from '@interface-images/select-arrow-down-active.svg'
import { ReactComponent as ArrowDownIcon } from '@interface-images/select-arrow-down-inactive.svg'
import { ReactComponent as ArrowUpIconActive } from '@interface-images/select-arrow-up-active.svg'
import { ReactComponent as ArrowUpIcon } from '@interface-images/select-arrow-up-inactive.svg'
import Body from './Body'
import { ArrowWrapper, HeaderContainer, StyledTitle } from './styled'

const FilialItem: FC<ListItemProps<Filial>> = ({
  isLoading,
  handleClickOnItem,
  opened,
  item: { title, id },
}) => {
  const header: FC<AccordionHeaderProps> = ({ hovered, expanded }) => {
    const arrowIcon = expanded
      ? hovered
        ? <ArrowUpIconActive />
        : <ArrowUpIcon />
      : hovered
        ? <ArrowDownIconActive />
        : <ArrowDownIcon />

    return (
      <HeaderContainer>
        <StyledTitle mySize="h4">{title}</StyledTitle>
        <ArrowWrapper>{arrowIcon}</ArrowWrapper>
      </HeaderContainer>
    )
  }

  return (
    <Accordion
      skeletonHeight={60}
      handleClickOnHeader={handleClickOnItem}
      expanded={opened}
      initLoading={isLoading}
      withoutArrow
      Header={header}
      Body={({ onChangeSize, toggleLoading }) => (
        <Body
          onChangeSize={onChangeSize}
          toggleLoading={toggleLoading}
          id={id}
        />
      )}
    />
  )
}

export default FilialItem
